(() => {
  const checkoutSelector = 'button[name="checkout"], input[name="checkout"]';
  let alcoholWithoutFood = false;

  const updateCheckoutButtons = () => {
    window.CartCheckoutValidation?.setReason(
      'alcohol-without-food',
      alcoholWithoutFood,
      'Alcohol must be purchased with food before checkout.'
    );

    document.querySelectorAll('[data-alcohol-checkout-message]').forEach(message => {
      message.hidden = !alcoholWithoutFood;
    });
  };

  window.updateCartAlcoholValidation = (root = document) => {
    const marker = root.querySelector('[data-cart-alcohol-validation]');
    alcoholWithoutFood = marker?.dataset.requiresFood === 'true';
    document.documentElement.classList.toggle('cart-alcohol-without-food', alcoholWithoutFood);
    updateCheckoutButtons();
  };

  const showCheckoutWarning = () => {
    const messages = Array.from(document.querySelectorAll('[data-alcohol-checkout-message]:not([hidden])'));
    const message = messages.find(element => element.offsetParent !== null) || messages[0];
    if (!message) return;

    message.focus({ preventScroll: true });
    message.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  };

  document.addEventListener('click', event => {
    const requirementsLink = event.target.closest('[data-alcohol-requirements-link]');
    if (requirementsLink) {
      const notice = document.querySelector(requirementsLink.getAttribute('href'));
      if (!notice) return;

      event.preventDefault();
      notice.focus({ preventScroll: true });
      notice.scrollIntoView({ behavior: 'smooth', block: 'center' });
      return;
    }

    const checkout = event.target.closest(checkoutSelector);
    if (!checkout || !alcoholWithoutFood) return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showCheckoutWarning();
  }, true);

  document.addEventListener('submit', event => {
    if (!alcoholWithoutFood || event.target.id !== 'cart') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    showCheckoutWarning();
  }, true);

  document.addEventListener('change', event => {
    if (alcoholWithoutFood && event.target.matches('terms-checkbox input[type="checkbox"]')) {
      window.requestAnimationFrame(() => window.CartCheckoutValidation?.update());
    }
  }, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => window.updateCartAlcoholValidation());
  } else {
    window.updateCartAlcoholValidation();
  }
})();
